import {AfterViewInit, Component, Inject, PLATFORM_ID} from '@angular/core';
import {
  ArticleInterface,
  Section,
  SectionInterface
} from "../drupal/entities";
import {ActivatedRoute, Router} from "@angular/router";
import {Drupal7Service} from "../drupal/drupal7.service";
import {ArticleResult, TaxonomyTermResult} from "../drupal/resultTypes";
import {tap} from "rxjs";
import {EntityMetaService} from "../drupal/entity-meta.service";
import {Drupal7mappingService} from "../drupal/drupal7mapping.service";
import {AdPositionName} from "../ads/ad-position/ad-position-map";
import {AdServeServiceService} from "../ads/ad-serve/ad-serve-service.service";
import {isPlatformBrowser} from "@angular/common";
import {SsspService} from "../seznam/sssp.service";

@Component({
  selector: 'app-section-detail',
  templateUrl: './section-detail.component.html',
  styleUrls: ['./section-detail.component.css'],
})
export class SectionDetailComponent implements AfterViewInit {
  section: SectionInterface | undefined;
  articles: Array<ArticleInterface> | undefined;
  titlePath: string | null = null;
  page: number = 0;
  protected readonly AdPositionName = AdPositionName;
  private readonly isBrowser: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private entityMeta: EntityMetaService,
    private drupal7: Drupal7Service,
    private drupal7mapping: Drupal7mappingService,
    private adServe: AdServeServiceService,
    private sssp: SsspService,
    @Inject(PLATFORM_ID) platformId: string,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.loadArticles();
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      this.sssp.setPageViewId();

      this.adServe.serveAds([
        AdPositionName.leaderboard,
        AdPositionName.square,
        AdPositionName.stickySquare,
        AdPositionName.footerboard,
      ]);
    }
  }

  loadArticles(offset: number = 0) {
    this.route.paramMap.pipe(
      tap(params => {
        this.titlePath = params.get('titlepath');
        this.drupal7.getTaxonomyTerm(this.titlePath).pipe(
          tap((data: TaxonomyTermResult) => {
            this.section = this.drupal7mapping.mapSection(data);
            this.articles = [];
            this.entityMeta.setMeta(new Section(this.section));
          }),
          tap(data => {
            //this.drupal7.getViewArticles({viewName: 'taxonomy_term_rubrika', displayId: 'services_1', args: [this.section?.id], offset: offset}).subscribe((data: Array<ArticleResult>) => this.mapArticles(data));
          })
        ).subscribe(params => {})
      })
    ).subscribe(params => {});
  }

  private mapArticles(data: Array<ArticleResult>) {
    this.articles = [];
    Object.entries(data).forEach(([key, articleResult]) => {
      this.articles = this.drupal7mapping.mapArticles(data);
    });
  }

  private mapMoreArticles(data: Array<ArticleResult>) {
    this.drupal7mapping.mapArticles(data).forEach((article) => {
      // @ts-ignore
      this.articles.push(article);
    });
  }
}
